import { FC, useCallback, useContext, useEffect, useState } from 'react';
import { debounce, get, some } from 'lodash';
import classnames from 'classnames';
import { InputGroup, InputLeftElement } from '@chakra-ui/react';
import { TableContext } from './';
import { CbSelect } from '../CbSelect';
import { CbInput } from '../Inputs/CbInput';
import { ICON_BY_NAME } from '../Icons/Icon';
import styles from './Search.module.css';
export const Search: FC = () => {
  const {
    handleSearch,
    searchInfo
  } = useContext(TableContext);
  const [columnId, setColumnId] = useState<string>(get(searchInfo, '[0].id', ''));
  const [searchText, setSearchText] = useState<string>('');
  const debouncedSearch = useCallback(debounce(handleSearch, 375), []);
  useEffect(() => debouncedSearch({
    columnId,
    text: searchText
  }), [columnId, searchText]);

  /* A column we've currently selected as a search option may be removed from the table.
     We should re-set the filter to the first available filter if that happens.
  */
  useEffect(() => {
    const columnStillRelevant = some(searchInfo, {
      id: columnId
    });
    if (!columnStillRelevant) {
      setColumnId(get(searchInfo, '[0].id', ''));
      setSearchText('');
    }
  }, [searchInfo]);
  if (searchInfo.length === 0) return null;
  const options = searchInfo.map(({
    id,
    name
  }) => ({
    name,
    value: id
  }));
  const handleSearchColumnChange = ({
    value
  }) => setColumnId(value);
  const handleSearchTextChange = ({
    target: {
      value
    }
  }) => setSearchText(value);
  const selectedColumn = searchInfo.find(col => col.id === columnId);
  const columnDescription = get(selectedColumn, 'name', '');
  const searchLabel = get(selectedColumn, 'searchLabel', '');
  const onlyOneOption = options.length === 1;
  const searchPlaceholder = onlyOneOption ? searchLabel ? `Search by ${searchLabel}` : `Search ${columnDescription}` : 'Search';
  const searchElement = onlyOneOption ? null : <div className={styles.searchSelectContainer}>
      <CbSelect borderColor="transparent" className={styles.searchSelect} getValueFromOption={option => option.value} onChange={handleSearchColumnChange} options={options} size="xs" value={columnId} _hover={{
      borderColor: 'transparent'
    }} />
    </div>;
  return <InputGroup className={styles.searchInputContainer} data-sentry-element="InputGroup" data-sentry-component="Search" data-sentry-source-file="Search.tsx">
      <InputLeftElement children={<ICON_BY_NAME.search boxSize="12px" />} pointerEvents="none" sx={{
      h: 'var(--chakra-sizes-10)',
      w: 'var(--chakra-sizes-10)'
    }} data-sentry-element="InputLeftElement" data-sentry-source-file="Search.tsx" />
      <CbInput variant="cb-base" borderColor="cloud.600" className={classnames(styles.searchInput, {
      [styles.inputWSelect]: !onlyOneOption
    })} onChange={handleSearchTextChange} paddingX="2rem" placeholder={searchPlaceholder} value={searchText} _placeholder={{
      fontSize: '14px'
    }} data-sentry-element="CbInput" data-sentry-source-file="Search.tsx" />
      {searchElement}
    </InputGroup>;
};